class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'keyup',
      (evt) => evt.code === 'Escape' && this.close(),
    );
    this.querySelector('#CartDrawer-Overlay').addEventListener(
      'click',
      this.close.bind(this),
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();

      if (this.querySelector('cart-recommendation')) {
        this.querySelector('cart-recommendation').style.display = 'block';
      }

      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role'))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn =
          this.classList.contains('is-empty') ?
            this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement =
          this.querySelector('.drawer__inner') ||
          this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    document.body.classList.add('overflow-hidden');
    document.body.classList.add('overflow-hidden-active');
  }

  close() {
    if (this.querySelector('cart-recommendation')) {
      this.querySelector('cart-recommendation').style.display = 'none';
    }
    document.querySelector('cart-drawer').classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('overflow-hidden-active');
    //this.open();
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute(
        'aria-controls',
        cartDrawerNote.nextElementSibling.id,
      );
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open'),
      );
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState, stopOpenCartDrawer) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement =
        section.selector ?
          document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector,
      );

      if (document.querySelector('cart-recommendation')) {
        document.querySelector('cart-recommendation').style.display = 'block';
      }
    });

    setTimeout(() => {
      // this code done by TT
      if (stopOpenCartDrawer) return;
      this.querySelector('#CartDrawer-Overlay').addEventListener(
        'click',
        this.close.bind(this),
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    const sections = [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];

    const discountBubble = document.getElementById('bulk-discount-bubble');
    if (discountBubble) {
      const parentSection = discountBubble.closest('.shopify-section');
      if (parentSection) {
        sections.push({
          id: parentSection.id.replace('shopify-section-', ''),
          selector: '#bulk-discount-bubble',
        });
      } else {
        sections.push({
          id: 'bulk-discount-bubble',
        });
      }
    }

    return sections;
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    const sections = [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
    const discountBubble = document.getElementById('bulk-discount-bubble');
    if (discountBubble) {
      const parentSection = discountBubble.closest('.shopify-section');
      if (parentSection) {
        sections.push({
          id: 'bulk-discount-bubble',
          section: parentSection.id.replace('shopify-section-', ''),
          selector: '#bulk-discount-bubble',
        });
      } else {
        sections.push({
          id: 'bulk-discount-bubble',
          section: 'bulk-discount-bubble',
          selector: '.shopify-section',
        });
      }
    }
    return sections;
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// Cart recommendation product by TT
if (!customElements.get('cart-recommendation')) {
  customElements.define(
    'cart-recommendation',
    class CartRecommendation extends HTMLElement {
      constructor() {
        super();

        this.initSwiper();
      }

      initSwiper() {
        this.swiperSlides = parseFloat(this.getAttribute('data-slides'));
        this.swiperSlidesMobile = parseFloat(
          this.getAttribute('data-slides-mobile'),
        );
        this.swiperSlidesGap = parseFloat(this.getAttribute('data-slides-gap'));
        this.swiper = new Swiper(
          this.querySelector('[id^="SwiperCartRecommendation"]'),
          {
            slidesPerView: this.swiperSlidesMobile,
            spaceBetween: this.swiperSlidesGap,
            allowTouchMove: true,
            mousewheel: true,
            // And if we need scrollbar
            scrollbar: {
              el: this.querySelector('[id^="swiper-scrollbar"]'),
              draggable: true,
            },
            freeMode: true,
            freeModeMomentum: true,
            speed: 4500,
            breakpoints: {
              750: {
                slidesPerView: this.swiperSlides,
                spaceBetween: this.swiperSlidesGap,
              },
            },
          },
        );
      }
    },
  );
}
